const USER_AGENT = window.navigator.userAgent.toLowerCase();
const MAC_OS_PLATFORM = /(macintosh|macintel|macppc|mac68k|macos)/i;
const WINDOWS_PLATFORM = /(win32|win64|windows|wince)/i;
const IOS_PLATFORM = /(iphone|ipad|ipod|ios)/i;
const ANDROID_PLATFORM = /android/i;
const LINUX_PLATFORM = /linux/i;

export const getOS = () => {
  let os = null;

  if (MAC_OS_PLATFORM.test(USER_AGENT)) {
    os = 'MacOS' as const;
  } else if (IOS_PLATFORM.test(USER_AGENT)) {
    os = 'iOS' as const;
  } else if (WINDOWS_PLATFORM.test(USER_AGENT)) {
    os = 'Windows' as const;
  } else if (ANDROID_PLATFORM.test(USER_AGENT)) {
    os = 'Android' as const;
  } else if (LINUX_PLATFORM.test(USER_AGENT)) {
    os = 'Linux' as const;
  }

  return os ?? 'Windows';
};

const isOs = (os: 'MacOS' | 'Windows' | 'Linux' | 'iOS' | 'Android') => () =>
  getOS() === os;

export const isMacOS = isOs('MacOS');
export const isWindows = isOs('Windows');
export const isLinux = isOs('Linux');
export const isIOS = isOs('iOS');
export const isAndroid = isOs('Android');
